import React from 'react';

import classNames from 'classnames/bind';
import style from './Banner.scss';
const ctx = classNames.bind(style);

import Spreader from '../Spreader';

import { CSSTransition, TransitionGroup } from 'react-transition-group';

const Banner = props => (
  <div
    className={ctx('banner')}
    style={{ backgroundImage: `url(${props.backgroundImage})` }}
  >
    <Spreader>
      <div className={ctx('inner')}>{props.title}</div>
    </Spreader>
  </div>
);

export default Banner;
